import { render, staticRenderFns } from "./properties-component-social-links.vue?vue&type=template&id=15a4fc7e&scoped=true"
import script from "./properties-component-social-links.vue?vue&type=script&lang=js"
export * from "./properties-component-social-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4fc7e",
  null
  
)

export default component.exports